
export const config = {
    basename: "/",
    api: 'https://neocom.net.ua/public-api-proxy/',
    defaultOSMCenter: [31.3073, 51.5038],
    defaultOSMZoom: 12,
    defaultOSMSource: 'google', // osm or google
    mobileWidthBarier: 1300,
    debug: false
}
